import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import DeleteAccountConfirmPage from '@/features/account/delete-account-confirm';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/excluir-conta/')({
  component: () => (
    <HomeGate>
      <DeleteAccountConfirmPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
